export const hasEvenLengthSize = (array: Array<unknown>): boolean =>
  array.length % 2 === 0

export const removeFalsy = <T>(array: Array<T>): Array<T> =>
  array.filter(Boolean)
